import { render } from "./WMS.vue?vue&type=template&id=334ffe87&scoped=true"
import script from "./WMS.vue?vue&type=script&lang=js"
export * from "./WMS.vue?vue&type=script&lang=js"

import "./WMS.vue?vue&type=style&index=0&id=334ffe87&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-334ffe87"

export default script